module.exports = __webpack_public_path__ + "static/media/bringForward.8cf7df14.svg";